import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import { useStateMachineContext } from '@common/context/StateMachineContext';

import { ROLES } from '../constants';

import ContactUsHeader from './ContactUsHeader';

const InitView = () => {
  const { send } = useStateMachineContext();

  const handleRoleClick = role => {
    Metrics.ga.sendEvent('contact_form_revamp', 'role_clicked', `${role}`);
    send('SELECT', { role });
  };

  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader isInvisible />
      {ROLES.map(role => (
        <Button
          key={role}
          color="primary"
          size="large"
          fullWidth
          onClick={() => handleRoleClick(role)}
          className="contact-us-form__button"
        >
          {trans(`contact-us.${role}`)}
        </Button>
      ))}
    </div>
  );
};

export default InitView;
